// extracted by mini-css-extract-plugin
module.exports = {"item":"TokenItem_item__2TWZs","button":"TokenItem_button__2_-Dg","added":"TokenItem_added__25bUH"};